var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibilityPassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.15 4.717a2.226 2.226 0 100 4.452 2.226 2.226 0 000-4.452zM6.622 6.943a3.526 3.526 0 117.052 0 3.526 3.526 0 01-7.052 0z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.725 1.748A11.762 11.762 0 0119.601 5.47l.262.37a2.184 2.184 0 01-.006 2.63A11.76 11.76 0 01.51 8.153l-.005-.008-.107-.166a2.184 2.184 0 01.059-2.593l.055-.078a11.762 11.762 0 014.213-3.56zm5.362.052a10.461 10.461 0 00-8.523 4.272l-.054.076A.884.884 0 001.48 7.26l.113.174a10.462 10.462 0 0017.224.255.884.884 0 00-.01-1.089l-.268-.379a10.464 10.464 0 00-8.453-4.42z",
    fill: "#C4C4C4"
  })));
}
export default SvgVisibilityPassword;